import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledTooltip = styled.div`
    position: absolute;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    font-family: ${({ theme }) => theme.style_primary};
    transition:
        top 0.15s ease-out,
        left 0.15s ease-out,
        transform 0.15s ease-out;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    min-width: 277px;
    line-height: normal;
    padding: 12px;
    pointer-events: none;
    z-index: 10;
`;

function TikTokTooltipCard({
    left,
    top,
    width,
    chartWidth,
    chartHeight,
    offset = 10,
    children,
    ...rest
}) {
    const ref = useRef(null);

    useLayoutEffect(() => {
        if (ref.current) {
            const measuredWidth = ref.current.offsetWidth;
            const measuredHeight = ref.current.offsetHeight;
            const x =
                left > chartWidth / 2
                    ? left - measuredWidth - offset
                    : left + offset;
            const y =
                top > chartHeight / 2
                    ? top - measuredHeight - offset
                    : top + offset;
            ref.current.style.left = `${x}px`;
            ref.current.style.top = `${y}px`;
        }
    }, [left, top, chartWidth, chartHeight, offset]);

    return (
        <StyledTooltip ref={ref} style={{ width }} {...rest}>
            {children}
        </StyledTooltip>
    );
}

export default TikTokTooltipCard;
